import PropTypes from 'prop-types';

export const MfaState = ({ usuario, handleDisableMfa, showSpinner }) => {
    return (
        <div className="col-12 mt-2">
            <div className="admin-list-card p-3 admin-form-mfa-inner">
                <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
                    <div>
                        <h6 className="mb-1 fw-semibold text-dark">Autenticación de dos factores (MFA)</h6>
                        <p className="mb-0 text-muted small">Seguridad adicional para el inicio de sesión.</p>
                    </div>
                    <div className="flex-shrink-0">
                        {usuario.mfaConfirmado ?
                            <div className="d-flex flex-wrap align-items-center gap-2">
                                <span className="badge bg-success px-3 py-2 rounded-pill">MFA activo</span>
                                <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm rounded-pill px-3"
                                    onClick={handleDisableMfa}
                                    disabled={showSpinner}
                                >
                                    Deshabilitar
                                </button>
                            </div>
                            : <span className="badge bg-secondary px-3 py-2 rounded-pill">MFA inactivo</span>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
MfaState.propTypes = {
    usuario: PropTypes.shape({
        mfaConfirmado: PropTypes.bool,
    }),
    handleDisableMfa: PropTypes.func,
    showSpinner: PropTypes.bool,
}